import { type HttpInterceptorFn } from '@angular/common/http';

import { environment } from '@environments/environment';

function joinUrl(base: string, path: string): string {
  if (!base.endsWith('/') && !path.startsWith('/')) {
    return `${base}/${path}`;
  }

  if (base.endsWith('/') && path.startsWith('/')) {
    return `${base}${path.slice(1)}`;
  }

  return `${base}${path}`;
}

export const baseUrlInterceptor: HttpInterceptorFn = (request, next) => {
  const url = request.url;

  const isI18nRequest = url.includes('i18n');
  if (isI18nRequest) {
    return next(request);
  }

  const isExternalRequest = url.startsWith('http');
  if (isExternalRequest) {
    return next(request);
  }

  const apiRequest = request.clone({
    url: joinUrl(environment.apiUrl, url),
  });

  return next(apiRequest);
};
